import React from 'react';
import { useOpts } from '../../../context';
import { EventAction, EventSurface } from '../../../types/events';
import SearchTabGrid from './SearchTabGrid';
import usePageTrackingImpression from '../../../hooks/usePageTrackingImpression';
import Loading from '../../components/Loading';
export var InitialProviders = function (_a) {
    var onTabItemClick = _a.onTabItemClick, onCantFind = _a.onCantFind, tab = _a.tab, initialProviders = _a.initialProviders, initialProvidersLoading = _a.initialProvidersLoading;
    var opts = useOpts();
    var fireProperEventType = opts.fireProperEventType;
    usePageTrackingImpression(EventSurface.SEARCH_DEFAULT);
    if (initialProvidersLoading) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(SearchTabGrid, { tab: tab, providers: (initialProviders === null || initialProviders === void 0 ? void 0 : initialProviders[tab]) || [], onSelect: onTabItemClick, onCantFind: function () {
            fireProperEventType(EventAction.TAP_CANT_FIND, opts, {
                tab: tab,
            });
            onCantFind();
        } }));
};
